<template>
	<div class="trade-intro">
		<h2 data-aos="fade-in">商标介绍</h2>
		<h3 data-aos="fade-up">商标业务<small>TRADEMARK  BUSSINESS</small></h3>
		<div class="trade-intro.img" data-aos="fade-up">
			<img src="../assets/trademarks/trade-intro.png" alt="">
		</div>
		<h3 data-aos="fade-up">商标疑难杂症<small>TRADEMARK  BUSSINESS  FAQ</small></h3>
		<ul>
			<li v-for="(question,index) in questions" :key="index" data-aos="fade-up">
				<p><span>Q</span>{{question.q}}</p>
				<p><span>A</span>{{question.a}}</p>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				questions:[
					{
						q:'商标分哪些类型？',
					    a:'任何能够将自然人、法人或者其他组织的商品与他人的商品区分开的标志，包括文字、图形、字母、数字、三维标志、颜色组合和声音等，以及上述要素的组合，均可以作为商标申请注册'
					},
					{
						q:'哪些东西可注册商标？',
						a:'文字、图形、字母、数字、三维标志、颜色组合和声音，以及上述要素的组合，均可以作为商标申请注册。'
					},
					{
						q:'商标上的TM是什么意思？',
						a:'商标权宣告的标志，注册和未注册商标都可以使用。'
					},
					{
						q:'商标保护期限是多长？',
						a:'注册商标的有效期为10年。注册商标有效期满后需要继续使用的，应当在期满前的一年内申请续展注册。在此期间未能提出申请的，还有6个月的宽展期。宽展期内仍未提出申请的，期满后商标局将予以注销。'
					},
					{
						q:'商标申请费用是如何计算的？',
						a:'商标申请费用由官费和服务费构成，均按照商标、商品类别和商品数量进行计算。'
					},
					
				]
			}
		}
	}
</script>

<style lang="scss">
	@include component(trade-intro){
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		padding: 38px 30px;
		color: #333333;
		font-size: 16px;
		>h2{
			font-size:24px;
			font-weight:bold;
			color:#F47227;
			line-height:30px;
			margin: 0;
			text-align: left;
			border-bottom: 1px solid #F2F2F2;
			padding-bottom: 20px;
			position: relative;
			&:before{
				display: inline-block;
				content: '';
			    width: 100px;
				height: 5px;
				background:#F47227 ;
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}
		>h3{
			margin: 0;
			margin-top: 50px;
			font-size:24px;
			font-weight: 400;
			small{
				display: block;
				font-size:14px;
				color: #999999;
				margin-top: 10px;
			}
		}
		@include part(img){
			margin-top: 30px;
			display:flex;
			justify-content: center;
			img{
				display: block;
			}
		}
		>ul{
			margin-top: 30px;
			li{
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				border-bottom: 1px dashed #CCCCCC;
				padding-bottom: 20px;
				justify-content: center;
				&:not(:nth-child(1)){
					margin-top: 20px;
				}
			}
			p{
				text-align: left;
				position:relative;
				padding-left:40px;
				line-height: 30px;
				span{
					display: inline-block;
					width: 28px;
					height: 28px;
					background-color: #2278FC;
					border-radius:50%;
					text-align: center;
					line-height: 28px;
					color: #FFFFFF;
					font-weight: bold;
					position: absolute;
					left: 0;
					top: 0;
				}
				&:nth-child(1){
					margin-bottom:15px;
					color:#999999;
					span{
						background: #f47227 ;
					}
				}
			}
		}
	}
</style>
